import { useState, useEffect } from "react";
// material
import { Box, Card, Container } from "@mui/material";
import Label from "../Label";
// components
import Scrollbar from "../table/Scrollbar";
import ListToolbar from "../table/ListToolbar";
import TableView from "../Table";
import { parseDateTime } from "../../utils/tableFunctions";
import {
  getHistoryAccountFilterConditions,
  getHistoryAccountList,
  // getTransactionCSV,
} from "../../services/services";

import { SearchBox, SingleSelectType } from "../table/Filter";
import CircularLoader from "../circularLoader";
import CommonDialog from "../CustomDialog";
import HeaderHelpPage from "../HeaderHelpPage";
import AccountDetails from "../../pages/details/admin/AccountDetails";
import { pageNumber, rowsPerPage } from "../../utils/constants";

// ----------------------------------------------------------------------

export default function HistoryAccount() {
  const [historyAccount, setHistoryAccount] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});
  const [itemId, setItemId] = useState(null);

  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // ------------------ filterStuffies --------------------//
  const [reset, setReset] = useState(false);
  const [fLoaded, setFLoaded] = useState(false);
  const [historyAccountFilter, setHistoryAccountFilter] = useState({});

  const filterComponents = () => {
    if (fLoaded && Object.keys(fParams).length > 0) {
      return (
        <Box sx={{ mt: 3 }}>
          <SearchBox
            label="Email"
            options={fParams.email.map(email => email)}
            selected={historyAccountFilter}
            param={"email"}
            setSelected={setHistoryAccountFilter}
            reset={reset}
          />
          <SingleSelectType
            options={fParams.group.map((grp) => grp)}
            selected={historyAccountFilter}
            setSelected={setHistoryAccountFilter}
            label="Group"
            param={"group"}
            reset={reset}
          />
          <SingleSelectType
            id="true"
            options={[
              { name: "Approved", id: true },
              { name: "Not Approved", id: false },
            ]}
            selected={historyAccountFilter}
            setSelected={setHistoryAccountFilter}
            label="Approved"
            param={"is_approved"}
            reset={reset}
          />
          <SingleSelectType
            options={["Add", "Remove", "Update"]}
            selected={historyAccountFilter}
            setSelected={setHistoryAccountFilter}
            label="Action"
            param={"action"}
            reset={reset}
          />
        </Box>
      );
    }
  };

  const queryPage = (queryParams, filters) => {
    setLoaded(false);
    getHistoryAccountList({
      setResponse: setHistoryAccount,
      filter: filters || historyAccountFilter,
      setLoaded: setLoaded,
      queryParams: queryParams,
    });
    setPagination(queryParams);
  };

  const onFilterSubmit = () => {
    queryPage({
      page: 1,
      page_size: pagination.page_size,
    }, historyAccountFilter);
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  useEffect(() => {
    getHistoryAccountFilterConditions(setFParams, setFLoaded);
    queryPage(pagination);
  }, []);

  const formatData = (input) => {
    let tableData = [];
    const results = input?.results || [];
    results.forEach(({ action, created_at, email, group, id, is_approved }) => {
      tableData.push({
        id: id,
        email: email,
        action: action,
        created_on: parseDateTime(created_at),
        group: group && group.name,
        approved: (
          <>
            <Label variant="ghost" color={is_approved ? "success" : "error"}>
              {is_approved ? "YES" : "NO"}
            </Label>
          </>
        ),
      });
    });
    return tableData;
  };

  useEffect(() => {
    if (historyAccount) {
      setTableData(formatData(historyAccount));
    }
  }, [historyAccount]);

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      {loaded ? (
        <Card>
          <ListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            filter={true}
            loaded={loaded}
            filterFunction={filterComponents}
            onFilterSubmit={onFilterSubmit}
            setReset={setReset}
            csv={false}
          />
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/account-details~id~?action=true`}
              onSelectItem={(id) => setItemId(id)}
              count={historyAccount?.count || 0}
              query={filterName}
              data={historyAccount?.results || []}
              pagination={pagination}
              getNext={queryPage}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}

      {itemId && (
        <CommonDialog
          title={<HeaderHelpPage title="Account Details" variant="h5" mb={0} />}
          onClose={() => setItemId(null)}
        >
          <AccountDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Container>
  );
}
